var exports = {
  "k": "xe533113f--dec4ba--container",
};

module.exports = exports;
